import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { ServiceClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.ServizioQuery],
  create: [SystemAuthorizations.ServizioAdd],
  edit: [SystemAuthorizations.ServizioUpdate],
  delete: [SystemAuthorizations.ServizioDelete],
});

export const validationSchemaServicesFilter = yup.object({});

export const headCells: HeadCell<ServiceClient, keyof ServiceClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];
